import { $globalSanityClient } from '@/sanity';

export default async function fetchTotalCount(type: string) {
  const result = await $globalSanityClient.fetch<number>(
    `count(*[_type == $type && !(_id in path("drafts.**"))])`,
    { type }
  );
  return result;
}
